module.exports = "/images/hub-preview-tablet.png?eb51511125421141c6414910a8429d52";